import { RuleId, RuleLevel } from '../../../types-v2';
export let SourceType = /*#__PURE__*/function (SourceType) {
  SourceType["VIDEO"] = "video";
  SourceType["AUDIO"] = "audio";
  return SourceType;
}({});
export const mediaAlternativesRule = {
  checker: _ref => {
    let {
      allMedia
    } = _ref;
    const failedElements = [];
    allMedia.forEach(_ref2 => {
      let {
        id,
        type
      } = _ref2;
      // If element has no type, it means it's not saved in the db yet
      if (type === undefined) {
        failedElements.push(id);
      }
    });
    const status = failedElements.length === 0 ? 'passed' : 'failed';
    return {
      failedElements,
      status: allMedia.length > 0 ? status : 'not-applicable'
    };
  },
  level: RuleLevel.Page,
  ruleId: RuleId.MEDIA_ALTERNATIVES
};
//# sourceMappingURL=media-alternatives.js.map